export const AppHeaderStyle = {
  borderHeight: 5,
  containerHeight: 60,
};
